import { render } from "./stock-in.vue?vue&type=template&id=5ff915ea&scoped=true"
import script from "./stock-in.vue?vue&type=script&lang=js"
export * from "./stock-in.vue?vue&type=script&lang=js"

import "./stock-in.vue?vue&type=style&index=0&id=5ff915ea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff915ea"]])

export default __exports__